module.exports = __webpack_public_path__ + "c353f0102a375395fed857380ac98c9d.png";